import { render, staticRenderFns } from "./AchievementInfo.vue?vue&type=template&id=21e44e98&scoped=true&"
import script from "./AchievementInfo.vue?vue&type=script&lang=js&"
export * from "./AchievementInfo.vue?vue&type=script&lang=js&"
import style0 from "./AchievementInfo.vue?vue&type=style&index=0&id=21e44e98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e44e98",
  null
  
)

export default component.exports